export const testimonials = [
  {
    id: 1,
    name: "Román Basualdo",
    company: "MSI",
    position: "Senior Sales Specialist",
    photo: "/testimonials/roman-basualdo.png",
    testimonial: "EBT nos conecta con canales de todo el país, nos permite entender sus necesidades y generar nuevas oportunidades de negocio con nuestro amplio portfolio."
  },
  {
    id: 2,
    name: "Nicolás Riveros",
    company: "LEXAR",
    position: "Regional Manager South Latam",
    photo: "/testimonials/nicolas-riveros.png",
    testimonial: "Estamos muy felices de ser parte del EBT! Queremos escucharte, compartir experiencias y presentarte todo el portfolio de soluciones que Lexar tiene para vos."
  },
  {
    id: 3,
    name: "Pablo Ance",
    company: "COOLER MASTER",
    position: "Channel Sales Manager SOLA",
    photo: "/testimonials/pablo-ance.png",
    testimonial: "EBT es una oportunidad para conectar con los principales canales, generar sinergias y compartir experiencias. Diremos presente con un portfolio innovador y preparado para las necesidades del canal."
  },
  {
    id: 4,
    name: "Marcela Franco",
    company: "SEAGATE",
    position: "Business Development",
    photo: "/testimonials/marcela-franco.png",
    testimonial: "EBT nos da la oportunidad de conectar con potenciales clientes, presentando nuestro portfolio de productos, y servicios que nos destacan en el mercado de almacenamiento."
  }
];

export const mockFormSubmission = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock form submission:', formData);
      resolve({ success: true, message: 'Tu solicitud fue recibida correctamente. Nuestro equipo validará la información y se comunicará contigo.' });
    }, 1000);
  });
};
